<template>
  <yv-form-search
    :formSearch="formSearch"
    :inlineSearchAction="true"
    :enableExport="false"
    @search="search"
    ref="formSearch"
  ></yv-form-search>
</template>

<script>
import YvFormSearch from "@/components/Base/YvFormSearch.vue";
import { getId } from "@/helpers/utils";
import { service_paths } from "@/constants/Services";
import { EVENT_TYPES } from "../Event/event-utils";
import { mapGetters } from "vuex";
import { DEFAULT_OPTION_ALL } from "@/constants";

const STUDENT_EVENT_TYPE = `student_${EVENT_TYPES.classEvent}`;
const SCHOOL_EVENT_TYPE = `school_${EVENT_TYPES.schoolEvent}`;
const CLASS_EVENT_TYPE = `class_${EVENT_TYPES.classEvent}`;
const VIRTUAL_MEETING = `event_${EVENT_TYPES.meetingEvent}`;

export default {
  name: "teacher-search-bar",
  components: { YvFormSearch },
  inject: ["refetchEvents"],
  data() {
    const eventTypeOpts = [
      ...DEFAULT_OPTION_ALL,
      {
        id: SCHOOL_EVENT_TYPE,
        name: this.$t("schedule.school_event")
      },
      {
        id: CLASS_EVENT_TYPE,
        name: this.$t("schedule.class_schedule")
      },
      {
        id: STUDENT_EVENT_TYPE,
        name: this.$t("schedule.student_schedule")
      },
      {
        id: VIRTUAL_MEETING,
        name: this.$t("schedule.virtual_meeting")
      }
    ];
    return {
      formSearch: [
        {
          label: this.$t("schedule.teacher_filter_event_type"),
          name: "type",
          value: "",
          options: eventTypeOpts,
          type: "select"
        }
      ]
    };
  },
  watch: {
    "formSearch.0.value": function(newSelectedEventType) {
      if (this.formSearch.length >= 2) {
        this.removeSecondFilteringField();
      }

      const isClassScheduleFiltering =
        newSelectedEventType === CLASS_EVENT_TYPE ||
        newSelectedEventType === VIRTUAL_MEETING;
      if (isClassScheduleFiltering) {
        this.appendFilterByClassField();
      }

      const isStudentScheduleFiltering =
        newSelectedEventType === STUDENT_EVENT_TYPE;
      if (isStudentScheduleFiltering) {
        this.appendFilterByStudentField();
      }
    }
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info"
    })
  },
  methods: {
    search() {
      this.refetchEvents();
    },
    fetchEnrolledClasses() {
      const teacherId = getId(this.userInfo);
      const queryParams = {
        limit: 9999,
        status: "On-going"
      };

      return this.$axios
        .get(`${service_paths.users}/${teacherId}/classes`, queryParams)
        .then(response => {
          const options = response?.data?.data.map(classInfo => ({
            id: getId(classInfo),
            name: classInfo.name
          }));

          return [...DEFAULT_OPTION_ALL, ...options];
        });
    },
    fetchStudents() {
      const teacherId = getId(this.userInfo);

      return this.$axios
        .get(`${service_paths.users}/${teacherId}/assigned-students`)
        .then(response => {
          const options = response?.data?.data.map(studentInfo => ({
            id: getId(studentInfo),
            name: this.generateStudentOptName(studentInfo)
          }));
          return [...DEFAULT_OPTION_ALL, ...options];
        });
    },
    generateClassFilter(options) {
      return {
        label: this.$t("schedule.teacher_filter_class_event"),
        name: "class_id",
        value: "",
        options,
        type: "select"
      };
    },
    generateStudentFilter(options) {
      return {
        label: this.$t("schedule.teacher_filter_student_event"),
        name: "student_id",
        value: options[0]?.id, // ? default select first option
        options,
        type: "select",
        width: 30
      };
    },
    async appendFilterByClassField() {
      const enrolledClasses = await this.fetchEnrolledClasses();
      const filterByClassField = this.generateClassFilter(enrolledClasses);

      return (this.formSearch = [...this.formSearch, filterByClassField]);
    },
    async appendFilterByStudentField() {
      const students = await this.fetchStudents();
      const filterByStudentField = this.generateStudentFilter(students);

      return (this.formSearch = [...this.formSearch, filterByStudentField]);
    },
    removeSecondFilteringField() {
      this.formSearch.splice(1);
    },
    getQueryParams() {
      const queryParams = this.$refs.formSearch.getQueryParams();

      // ? eventTypeOpts has type with prefix, so we should remove it
      const type = queryParams.type.split("_")[1];
      return {
        ...queryParams,
        type
      };
    },
    generateStudentOptName(student) {
      const subfixName = student.student_code
        ? ` - ${student.student_code}`
        : "";

      return `${student.full_name}${subfixName}`;
    }
  }
};
</script>
